import { Injectable, inject, DestroyRef } from '@angular/core';

import { Router } from '@angular/router';

import { UserIdleService } from 'angular-user-idle';

import { BnNgIdleService } from 'bn-ng-idle';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({

  providedIn: 'root',

})

export class SessionService {

  private readonly userIdleService = inject(UserIdleService);

  private readonly bnIdleService = inject(BnNgIdleService);

  private readonly destroyRef = inject(DestroyRef);

  // ✅ Start watching user activity

  startWatch() {

    this.userIdleService.startWatching();

  }

  // ✅ Timer start listener (auto cleaned)

  timerStart() {

    this.userIdleService

      .onTimerStart()

      .pipe(takeUntilDestroyed(this.destroyRef))

      .subscribe(() => {

        // handle timer ticks if needed

      });

  }

  // ✅ Stop timer

  timerStop() {

    this.userIdleService.stopTimer();

  }

  // ✅ Kill session on timeout (auto cleaned)

  killSession(router: Router) {

    this.userIdleService

      .onTimeout()

      .pipe(takeUntilDestroyed(this.destroyRef))

      .subscribe(() => {

        localStorage.clear();

        this.userIdleService.stopTimer();

        this.userIdleService.stopWatching();

        router.navigate(['/login']);

      });

  }

  // ✅ Stop watching completely

  stopWatching() {

    this.userIdleService.stopWatching();

  }

  // ✅ BN idle watcher (auto cleaned)

  startBnWatch(router: Router) {

    const time = 28800;

    this.bnIdleService

      .startWatching(time)

      .pipe(takeUntilDestroyed(this.destroyRef))

      .subscribe((isTimedOut: boolean) => {

        if (isTimedOut) {

          localStorage.clear();

          router.navigate(['/login']);

        }

      });

  }

  // ✅ Reset BN timer (SAFE)

  resetBnTimer() {

    this.bnIdleService.resetTimer();

  }

  // ✅ Stop BN timer

  stopBnTimer() {

    this.bnIdleService.stopTimer();

  }

}
 